<template>
  <div class="waterHazard survey-template">

    <table>
      <thead>
        <tr class="blue accent-4 white-text">
          <th>Water Shortage Hazard</th>
        </tr>
      </thead>
    </table>
    <div :id="key" v-for="(item, key) in dataSurvey.survey" :key="key" style="margin: 12px 0px;"
      v-show="key !== 'grandTotal' && key !== 'water_resiliency_features' && key !== 'water_resiliency_complete'">
      <table>
        <thead v-if="typeof item === 'object'">
          <tr v-if="key === 'manualEssential'">
            <th colspan="2"><!-- {{ waterHazardSchema[key].label }} --> Non-standard - Essential Household needs</th>
          </tr>
          <tr v-if="key === 'essential'">
            <th colspan="2">Standard - {{ waterHazardSchema[key].label }}</th>
          </tr>
          <tr v-if="key === 'nonEssential'">
            <th colspan="2">{{ waterHazardSchema[key].label }}</th>
          </tr>
        </thead>
        <!--  -->
        <tbody v-if="key === 'essential'">
          <tr v-for="(level2, key2) in item" :key="key2">
            <td colspan="2">
              <b>{{ waterHazardSchema.essential[key2] }}</b>
              <ul>
                <li v-if="level2.totalConsumption">
                  Total Consumption: <span class="grey-text text-darken-2">{{ $_displayFormat(level2.totalConsumption) }}
                    gallons</span>
                </li>
                <li v-if="level2.totalPerson">
                  Total persons: <span class="grey-text text-darken-2">{{ level2.totalPerson }}</span>
                </li>
                <li v-if="level2.usePerPerson">
                  Use per person: <span class="grey-text text-darken-2">{{ level2.usePerPerson }}</span>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
        <!--  -->
        <tbody v-if="key === 'manualEssential'">
          <tr v-for="(level2, key2) in item" :key="key2">
            <td colspan="2">
              <b>{{ level2.title }}</b>
              <ul>
                <li v-if="level2.title">
                  Title: <span class="grey-text text-darken-2">{{ level2.title }}</span>
                </li>
                <li v-if="level2.calculationExplanation">
                  Calculation Explanation: <span class="grey-text text-darken-2">{{ level2.calculationExplanation
                  }}</span>
                </li>
                <li v-if="level2.totalConsumption">
                  Total Consumption <span class="grey-text text-darken-2">{{ level2.totalConsumption }} gallons</span>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
        <!--  -->
        <tbody v-if="key === 'nonEssential'">
          <tr v-for="(level2, key2) in item" :key="key2"
            v-show="level2.houseUse || level2.calculationExplanation || level2.totalConsumption">
            <td colspan="2">
              <b>{{ level2.name }}</b>
              <ul>
                <li v-if="level2.houseUse">
                  Used by no. of people: <span class="grey-text text-darken-2">{{ level2.houseUse }}</span>
                </li>
                <li v-if="level2.calculationExplanation">
                  Calculation Explanation: <span class="grey-text text-darken-2">{{ level2.calculationExplanation }}</span>
                </li>
                <li v-if="level2.totalConsumption">
                  Total Consumption <span class="grey-text text-darken-2">{{ $_displayFormat(level2.totalConsumption) }}
                    gallons</span>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
        <tfoot v-if="item.subTotal > 0">
          <tr>
            <td>
              Subtotal:
            </td>
            <td class="right-align">
              <span class="grey-text text-darken-2">{{ $_displayFormat(item.subTotal) }} gallons</span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!--   <div :id="key" v-for="(item, key) in dataSurvey.survey" :key="key">
      <div v-if="typeof item === 'object'">
        <h5 v-if="key === 'manualEssential' && hasNoEssential">
          <u>{{ waterHazardSchema[key].label }}</u>
        </h5>
        <h5 v-if="key === 'essential' && !hasNoEssential">
          <u>{{ waterHazardSchema[key].label }}</u>
        </h5>
        <h5 v-if="key === 'nonEssential'">
          <u>{{ waterHazardSchema[key].label }}</u>
        </h5>
      </div>

      <div v-if="key === 'essential' && !hasNoEssential">
        <div v-for="(level2, key2) in item" :key="key2">
          <b>{{ waterHazardSchema.essential[key2] }}</b>
          <ul>
            <li v-if="level2.totalConsumption">
              Total Consumption: <span class="grey-text text-darken-2">{{ $_displayFormat(level2.totalConsumption) }} gallons</span>
            </li>
            <li v-if="level2.totalPerson">
              Total persons: <span class="grey-text text-darken-2">{{level2.totalPerson}}</span>
            </li>
            <li v-if="level2.usePerPerson">
              Use per person: <span class="grey-text text-darken-2">{{level2.usePerPerson}}</span>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="key === 'manualEssential' && hasNoEssential">
        <div v-for="(level2, key2) in item" :key="key2">
          <b>{{ level2.title }}</b>
          <ul>
            <li v-if="level2.title">
              Title:
              <span class="grey-text text-darken-2">{{ level2.title }}</span>
            </li>
            <li v-if="level2.calculationExplanation">
              Calculation Explanation:
              <span class="grey-text text-darken-2">{{
                level2.calculationExplanation
              }}</span>
            </li>
            <li v-if="level2.totalConsumption">
              Total Consumption
              <span class="grey-text text-darken-2"
                >{{ level2.totalConsumption }} gallons</span
              >
            </li>
          </ul>
        </div>
      </div>

      <div v-if="key === 'nonEssential'">
        <div v-for="(level2, key2) in item" :key="key2">
          <b>{{ level2.name }}</b>
          <ul>
            <li v-if="level2.houseUse">
              Used by no. of people:
              <span class="grey-text text-darken-2">{{ level2.houseUse }}</span>
            </li>
            <li v-if="level2.calculationExplanation">
              Calculation Explanation:
              <span class="grey-text text-darken-2">{{
                level2.calculationExplanation
              }}</span>
            </li>
            <li v-if="level2.totalConsumption">
              Total Consumption
              <span class="grey-text text-darken-2"
                >{{ $_displayFormat(level2.totalConsumption) }} gallons</span
              >
            </li>
          </ul>
        </div>
      </div>

      <p class="right totals" v-if="item.subTotal > 0">
        Subtotal:
        <span class="grey-text text-darken-2"
          >{{ $_displayFormat(item.subTotal) }} gallons</span
        >
      </p>

      <div class="divider grey lighten-2"
        v-if="typeof item === 'object' && key !== 'water_resiliency_features'"></div>
    </div> -->
    <table style="margin-bottom: 24px; display:none;" class="hide">
      <thead>
        <tr>
          <th colspan="2">Grand Total</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Total</td>
          <td class="right-align">
            <span class="grey-text text-darken-2">{{ $_displayFormat(dataSurvey.survey.grandTotal) }} gallons</span>
          </td>
        </tr>
      </tbody>
    </table>

    <table>
      <thead>
        <tr>
          <th>{{ waterHazardSchema.water_resiliency_features.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <ul class="browser-default">
              <li v-for="(level2, key2) in dataSurvey.survey.water_resiliency_features" :key="key2">
                {{ waterHazardSchema.water_resiliency_features[level2] }}
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!--     <div class="section">
      <h5>
        <u>{{ waterHazardSchema.water_resiliency_features.label }}</u>
      </h5>
      <div
        v-for="(level2, key2) in dataSurvey.survey.water_resiliency_features"
        :key="key2"
      >
        <p>{{ waterHazardSchema.water_resiliency_features[level2] }}</p>
      </div>
    </div> -->

    <summary-assessment summary-label="Water Hazard" :data-value="dataSurvey" />
  </div>
</template>

<script>
import waterHazardSchema from "@/JsonSchemas/waterHazard";
import summaryAssessment from "@/components/admin/summaryAssessment.component";
export default {
  name: "WaterHazardReview",
  components: {
    summaryAssessment,
  },
  props: {
    dataSurvey: {
      type: Object,
    },
  },
  data() {
    return {
      waterHazardSchema,
      ready: false,
    };
  },
  computed: {
    hasNoEssential() {
      const { essential } = this.dataSurvey.survey;

      if (!essential) return true;

      const hasVal = Object.keys(essential).some((key) => {
        if (key !== "subTotal") {
          return !!essential[key].totalConsumption;
        }
      });
      return !hasVal;
    },
  },
  mounted() {
    this.dataSurvey && (this.ready = true);
  },
  methods: {
    $_displayFormat(val) {
      try {
        let newVal = parseInt(val);
        newVal = newVal.toLocaleString("en-Us", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        return newVal;
      } catch (error) {
        return 0;
      }
    },
  },
};
</script>
<style lang="scss">
.waterHazard {

  table {
    thead {
      background: rgba(0, 0, 0, 0.08);
      padding: 12px;
    }
  }

  td,
  th {
    border: 1px solid lightgray !important;
    padding: 12px;

    p {
      margin: 6px 0px;
    }
  }


  #essentialblock {
    b {
      font-size: 20px;
      font-weight: 500;
    }

    li {
      font-size: 18px;
      list-style-type: disc;
      margin-left: 24px;

      span {
        font-size: 16px;
      }
    }
  }

  .waterSubTotal {
    font-size: 24px;
  }

  .divider {
    width: 100%;
    height: 1px;
  }

  .totals {
    font-size: 18px;
    font-weight: 500;
  }
}</style>
